export default __webpack_public_path__ + "static/media/awsComingSoon.a833eee0.svg";